import React, { useState, useEffect } from 'react';
import './PasswordProtection.css';
import Logo01 from '../assets/logos/Assertion Logo & icon-01.svg';

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if already authenticated
  useEffect(() => {
    const auth = sessionStorage.getItem('demo_auth');
    if (auth === 'authenticated') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple password check (set via env variable in build)
    const correctPassword = process.env.REACT_APP_DEMO_PASSWORD || 'assertion2024';
    
    if (password === correctPassword) {
      sessionStorage.setItem('demo_auth', 'authenticated');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="password-protection">
      <div className="password-card">
        <div className="logo">
          <img src={Logo01} alt="Assertion" />
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            autoFocus
          />
          <button type="submit">Continue</button>
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default PasswordProtection;